import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import { facadeFactory, provideDefaultConfigFactory } from '@spartacus/core';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const PDF_INVOICES_FEATURE = 'pdfInvoices';
const PDF_INVOICES_CORE_FEATURE = 'pdfInvoicesCore';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function pdfInvoicesFacadeFactory() {
  return facadeFactory({
    facade: PDFInvoicesFacade,
    feature: PDF_INVOICES_FEATURE,
    methods: ['getInvoicesForOrder', 'getInvoicePDF']
  });
}
class PDFInvoicesFacade {
  static {
    this.ɵfac = function PDFInvoicesFacade_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PDFInvoicesFacade)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PDFInvoicesFacade,
      factory: () => pdfInvoicesFacadeFactory(),
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PDFInvoicesFacade, [{
    type: Injectable,
    args: [{
      providedIn: 'root',
      useFactory: pdfInvoicesFacadeFactory
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var InvoicesFields;
(function (InvoicesFields) {
  InvoicesFields["BASIC"] = "BASIC";
  InvoicesFields["DEFAULT"] = "DEFAULT";
  InvoicesFields["FULL"] = "FULL";
})(InvoicesFields || (InvoicesFields = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2022 SAP Spartacus team <spartacus-team@sap.com>
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function defaultRequestedDeliveryDateComponentsConfig() {
  const config = {
    featureModules: {
      [PDF_INVOICES_FEATURE]: {
        cmsComponents: ['AccountOrderDetailsPDFInvoicesComponent']
      },
      // by default core is bundled together with components
      [PDF_INVOICES_CORE_FEATURE]: PDF_INVOICES_FEATURE
    }
  };
  return config;
}
class PDFInvoicesRootModule {
  static {
    this.ɵfac = function PDFInvoicesRootModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PDFInvoicesRootModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: PDFInvoicesRootModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfigFactory(defaultRequestedDeliveryDateComponentsConfig)]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PDFInvoicesRootModule, [{
    type: NgModule,
    args: [{
      providers: [provideDefaultConfigFactory(defaultRequestedDeliveryDateComponentsConfig)]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { InvoicesFields, PDFInvoicesFacade, PDFInvoicesRootModule, PDF_INVOICES_CORE_FEATURE, PDF_INVOICES_FEATURE, defaultRequestedDeliveryDateComponentsConfig, pdfInvoicesFacadeFactory };
